import { render } from "./page_404.vue?vue&type=template&id=3e430d3a&scoped=true"
import script from "./page_404.vue?vue&type=script&lang=js"
export * from "./page_404.vue?vue&type=script&lang=js"

import "./page_404.vue?vue&type=style&index=0&id=3e430d3a&scoped=true&lang=less"

import exportComponent from "/Users/alex/Documents/Google Ads/Panorama Residence/Panorama web/panorama-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e430d3a"]])

export default __exports__